import { useRef, useState, useCallback } from "react";
import useOnScreen from "../../../../hooks/useOnScreen";
import ExternalProductLink from "../../merchandise/ExternalProductLink";
import { CustomTriggerTooltip } from "../../../core/basic/Tooltip";

interface Props {
  value?: string;
  columnWidth?: number;
  style?: React.CSSProperties;
  tooltipPosition?: "top" | "right" | "bottom" | "left";
}

const KeywordCell = (props: Props) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const innerCellRef = useRef<HTMLSpanElement>(null);

  const isVisible = useOnScreen(innerCellRef);

  const cellRef = useCallback(
    (node: HTMLSpanElement | null) => {
      if (node !== null) {
        setIsTruncated((node.parentElement?.scrollWidth ?? 0) > (node.parentElement?.clientWidth ?? 0));
      }
    },

    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [props.value, props.columnWidth, isVisible],
  );

  const isAsin =
    !!props.value
      ?.toString()
      .toLowerCase()
      .match(/b0[a-z0-9]{8}/i) && props.value.length === 10;
  // if its an asin then we need strip additional characters
  const asin =
    isAsin ?
      props.value
        ?.toString()
        .toLowerCase()
        .match(/b0[a-z0-9]{8}/i)?.[0]
    : null;

  return (
    <span
      ref={cellRef}
      style={{
        cursor: "pointer",
      }}
      data-tip={props.value}
      data-for={props.value}
    >
      <span ref={innerCellRef} style={props.style}>
        {isTruncated ?
          <CustomTriggerTooltip toolTip={props.value} placement={"top"} shouldFlip>
            <span role={"button"}>
              {isAsin ?
                <>
                  {props.value?.toUpperCase()} <ExternalProductLink asin={props.value?.toUpperCase()} />
                </>
              : props.value}
            </span>
          </CustomTriggerTooltip>
        : isAsin ?
          <>
            {asin?.toUpperCase()} <ExternalProductLink asin={asin?.toUpperCase()} />
          </>
        : props.value}
      </span>
    </span>
  );
};

export default KeywordCell;
